import { apiRequest } from "./axios";

/**
 * Hours Log API functions
 * Functions for managing daily hours log data
 */

/**
 * Create a manager hours-log entry.
 *
 * @param {Object} data Hours-log create payload.
 * @returns {Promise<Object>}
 */
export async function submitHoursLog(data) {
  const url = "/hourslog/submit";
  return await apiRequest(url, data, { method: "POST" });
}

/**
 * Hours-log rows for one calendar date.
 *
 * @param {string} date YYYY-MM-DD.
 * @returns {Promise<Array|Object>}
 */
export async function getHoursLogByDate(date) {
  const url = `/hourslog/${date}`;
  return await apiRequest(url, null, { method: "GET" });
}

/**
 * Hours-log rows for a week starting on `weekStart`.
 *
 * @param {string} weekStart YYYY-MM-DD week start.
 * @returns {Promise<Array|Object>}
 */
export async function getHoursLogByWeek(weekStart) {
  const url = `/hourslog/week/${weekStart}`;
  return await apiRequest(url, null, { method: "GET" });
}

/**
 * Patch an existing hours-log entry.
 *
 * @param {number|string} id HoursLogEvent PK.
 * @param {Object} data Partial hours-log fields.
 * @returns {Promise<Object>}
 */
export async function updateHoursLog(id, data) {
  const url = `/hourslog/${id}`;
  return await apiRequest(url, data, { method: "PATCH" });
}

/**
 * Delete an hours-log entry.
 *
 * @param {number|string} id HoursLogEvent PK.
 * @returns {Promise<Object>}
 */
export async function deleteHoursLog(id) {
  const url = `/hourslog/${id}`;
  return await apiRequest(url, null, { method: "DELETE" });
}
